import React from "react";
import socialLinks from "./data/socialLinks";

const Footer = () => {
  const { social, logos, middiv } = styles;
  const renderContent = () => {
    return socialLinks.map(item => {
      const { name, link, image } = item;
      return (
        <div key={name} style={social}>
          <a href={link}>
            <img style={logos} src={require(`${image}`)} alt={name} />
          </a>
        </div>
      );
    });
  };
  return (
    <div className="footer--container">
      <div style={middiv}>{renderContent()}</div>
    </div>
  );
};

const styles = {
  social: {
    width: "100%",
    height: "100%",
    margin: "0 1rem"
  },
  logos: {
    height: "100%",
    borderRadius: "100%",
    margin: "auto"
  },
  middiv: {
    margin: "auto",
    display: "flex",
    height: "75%"
  }
};

export { Footer };
